// extracted by mini-css-extract-plugin
export default {"loader":"results_loader__5S77W","list":"results_list__JOl7o","item-container":"results_item-container__078jk"};